<template>
  <div>
    <div class="uk-flex uk-flex-center uk-flex-row uk-flex-wrap">
      <form v-on:submit.prevent class="uk-margin uk-form uk-grid" uk-grid>
        <div class="uk-width-1-2 uk-text-left uk-flex uk-flex-column">
          <label for="carrierName" class="uk-form-label">Carrier Name</label>

          <InputField
            id="carrierName"
            v-model="carrierName"
            v-bind:class="{ 'uk-form-danger': textDanger }"
          ></InputField>
        </div>

        <div class="uk-width-1-2 uk-text-left uk-flex uk-flex-column">
          <label for="carrierName" class="uk-form-label">Carrier Email</label>

          <InputField
            id="carrierEmail"
            v-model="carrierEmail"
            v-bind:class="{ 'uk-form-danger': textDanger }"
          ></InputField>
        </div>

        <div class="uk-width-1-1 uk-flex-inline uk-flex-column uk-text-left">
          <!-- Need to do this so that button is same height as input fields, so this makes a label with whitespace -->
          <label class="uk-form-label">{{ '\xa0' }}</label>
          <button class="uk-button uk-button-primary uk-form-controls" v-on:click="addNewCarrier">
            <div uk-icon="icon: plus"></div>
            Add New Carrier
          </button>
        </div>
      </form>
    </div>

    <div v-if="loadingLoad">
      <div class="uk-alert-primary" uk-alert>
        <!-- <p>Saving load details for load {{loadNumber}}</p> -->
        <div uk-spinner></div>
      </div>
    </div>

    <div v-if="loadFormError" class="uk-form-danger">
      <p>{{ loadFormError }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UIkit from 'uikit';

import InputField from '../core/Input/InputField.vue';

import AddOnboardingCarrierMutation from '../../gql/company/mutations/AddOnboardingCarrier.gql';
import CompanyCompanyAssociationCarriersQuery from '../../gql/onboarding/CompanyCompanyCarriers.gql';

import { Address } from '../../types';

export function toUppercase(value: string): string {
  if (!value) return '';
  return value.toUpperCase();
}

// interface Props {}

interface Data {
  carrierName: string;
  carrierEmail: string;
  loadFormError: any;
  textDanger: boolean;
  loadingLoad: boolean;
}

// interface Computed {}

interface Methods {
  addNewCarrier: () => void;
}

const ADD_DRIVER_OPTION = '+ Add New Driver';
const ADD_CUSTOMER_OPTION = '+ Add New Customer';

// export default Vue.extend<Data, Methods, Computed, Props>({
export default defineComponent({
  name: 'EnterLoad',
  components: {
    InputField,
  },
  props: {},
  data() {
    return {

      carrierName: null,
      carrierEmail: null,

      loadFormError: null,
      textDanger: false,
      loadingLoad: false,
    };
  },
  computed: {},
  watch: {},

  methods: {
    toUppercase,
    addNewCarrier() {
      const vm = (this as any);

      const message = `Carrer is ${vm.carrierEmail}`;
      console.log(message);

      if (!(vm.carrierName && vm.carrierEmail)) {
        vm.loadFormError = 'Error: Fill out all fields';
        return;
      }

      vm.loadingLoad = true;

      vm.$apollo
        .mutate({
          mutation: AddOnboardingCarrierMutation,
          variables: {
            carrierName: vm.carrierName,
            carrierEmail: vm.carrierEmail,
          },
          update: (store, { data }) => {
            // const archivedContainers = data.archiveContainer.archivedContainers;
            const companyCompanyAssociationCarriers = (store.readQuery({
              query: CompanyCompanyAssociationCarriersQuery,
            }) as any).companyCompanyAssociationCarriers;

            const newAssociation = data.addOnboardingCarrier.brokerCarrierAssociation;
            companyCompanyAssociationCarriers.push(newAssociation);

            console.log('DATA IIS', data);
            store.writeQuery({
              query: CompanyCompanyAssociationCarriersQuery,
              data: {
                companyCompanyAssociationCarriers,
              },
            });
          },
        })
        // eslint-disable-next-line
        .then((data) => {
          vm.loadFormError = null;
          vm.textDanger = false;
          vm.loadingLoad = false;
          vm.carrierName = null;
          vm.carrierEmail = null;

          vm.$emit('addedCarrier');
        })
        .catch((error) => {
          console.error(`Could not add carrier - error ${error}`);

          vm.loadFormError = error.message;
          vm.loadingLoad = false;
        });
    },
  },
} as any);
</script>
